import fetch from 'isomorphic-fetch'
import { UploadRequest } from '@navjobs/upload'

const BASE_URL = process.env.REACT_APP_BASE_URL

export const Auth = {

  current: () => fetch(
    `${BASE_URL}/api/auth`, {
      credentials: 'include'
    }
  ),

  signIn: (email, encp, captcha) => fetch(
    `${BASE_URL}/api/auth`, {
      headers: { email, encp, captcha },
      credentials: 'include'
    }
  ),

  signOut: () => fetch(
    `${BASE_URL}/api/auth`, {
      method: 'DELETE',
      credentials: 'include'
    }
  ),

  resetPassword: (email, token, encp) => fetch(
    `${BASE_URL}/api/auth/reset-password`, {
      headers: { email, token, encp },
      credentials: 'include'
    }
  ),

  sendResetInstructions: (email, captcha) => fetch(
    `${BASE_URL}/api/auth/reset-instructions`, {
      headers: { email, captcha },
      credentials: 'include'
    }
  )

}

export const User = {

  getOne: (userId) => fetch(
    `${BASE_URL}/api/users/${userId}`, {
      credentials: 'include'
    }
  ),

  getAll: () => fetch(
    `${BASE_URL}/api/users`, {
      credentials: 'include'
    }
  ),

  create: (data, encp, captcha) => fetch(
    `${BASE_URL}/api/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'encp': encp,
        'captcha': captcha
      },
      body: JSON.stringify(data),
      credentials: 'include'
    }
  ),

  merge: (userId, data) => fetch(
    `${BASE_URL}/api/users/${userId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'include'
    }
  ),

  updatePassword: (userId, password, currentPassword) => fetch(
    `${BASE_URL}/api/users/${userId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'cpass': currentPassword
      },
      body: JSON.stringify({ password }),
      credentials: 'include'
    }
  ),

  uploadImage: (userId, file, progress) => UploadRequest({
    request: {
      fileName: 'profile',
      url: `${BASE_URL}/api/users/${userId}/image`,
      method: 'POST',
      withCredentials: true
    },
    files: [file],
    instance: () => null,
    progress
  }),

  verify: (email, token) => fetch(
    `${BASE_URL}/api/auth/verify`, {
      headers: { email, token },
      credentials: 'include'
    }
  )

}

export const UserStatic = {

  getImageURL: (userId, signature) =>
    `${BASE_URL}/api/users/${userId}/image#${signature}`,

  getExportArtistsURL: (from, to) =>
    `${BASE_URL}/api/users/export-artists?min=${from}&max=${to}`

}

export const Artwork = {

  getOne: (artworkId) => fetch(
    `${BASE_URL}/api/artworks/${artworkId}`, {
      credentials: 'include'
    }
  ),

  getAll: (start, limit, status) => fetch(
    `${BASE_URL}/api/artworks?status=${status}&start=${start}&limit=${limit}`, {
      credentials: 'include'
    }
  ),

  getCount: (status) => fetch(
    `${BASE_URL}/api/artworks/count?status=${status}`, {
      credentials: 'include'
    }
  ),

  uploadImage: (artworkId, file, progress) => UploadRequest({
    request: {
      fileName: 'artwork',
      url: `${BASE_URL}/api/artworks/${artworkId}/image`,
      method: 'POST',
      withCredentials: true
    },
    files: [file],
    instance: () => null,
    progress
  }),

  create: (data) => fetch(
    `${BASE_URL}/api/artworks`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'include'
    }
  ),

  merge: (artworkId, data) => fetch(
    `${BASE_URL}/api/artworks/${artworkId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
      credentials: 'include'
    }
  ),

  delete: (artworkId) => fetch(
    `${BASE_URL}/api/artworks/${artworkId}`, {
      method: 'DELETE',
      credentials: 'include'
    }
  ),

  publish: (artworkId) => fetch(
    `${BASE_URL}/api/artworks/${artworkId}/publish`, {
      method: 'POST',
      credentials: 'include'
    }
  ),

  unpublish: (artworkId) => fetch(
    `${BASE_URL}/api/artworks/${artworkId}/publish`, {
      method: 'DELETE',
      credentials: 'include'
    }
  ),

  replicateMarkups: (artworkId, frameType) => fetch(
    `${BASE_URL}/api/artworks/${artworkId}/replicateMarkups`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ frameType })
    }
  )
}

export const ArtworkStatic = {
  getImageURL: (artworkId) => `${BASE_URL}/api/artworks/${artworkId}/image`
}

export const Tag = {

  getOne: (tagId) => fetch(
    `${BASE_URL}/api/tags/${tagId}`, {
      credentials: 'include'
    }
  ),

  getAll: () => fetch(
    `${BASE_URL}/api/tags`, {
      credentials: 'include'
    }
  )

}

export const FrameType = {

  getOne: (frameTypeId) => fetch(
    `${BASE_URL}/api/frame-types/${frameTypeId}`, {
      credentials: 'include'
    }
  ),

  getAll: () => fetch(
    `${BASE_URL}/api/frame-types`, {
      credentials: 'include'
    }
  )

}

export const Sale = {

  getAll: (start, limit) => fetch(
    `${BASE_URL}/api/sales?start=${start}&limit=${limit}`, {
      credentials: 'include'
    }
  ),

  refresh: (sizeId) => fetch(
    `${BASE_URL}/api/sales/refresh`, {
      credentials: 'include'
    }
  )

}

export const SaleStatic = {
  getExportSalesURL: (from, to) =>
    `${BASE_URL}/api/sales/export?min=${from}&max=${to}`
}

export const Size = {

  getOne: (sizeId) => fetch(
    `${BASE_URL}/api/sizes/${sizeId}`, {
      credentials: 'include'
    }
  ),

  getAll: () => fetch(
    `${BASE_URL}/api/sizes`, {
      credentials: 'include'
    }
  )

}



// WEBPACK FOOTER //
// ./src/api/index.js